import { render, staticRenderFns } from "./ApplicationHR.vue?vue&type=template&id=c4a568c2&scoped=true&"
import script from "./ApplicationHR.vue?vue&type=script&lang=ts&"
export * from "./ApplicationHR.vue?vue&type=script&lang=ts&"
import style0 from "./ApplicationHR.vue?vue&type=style&index=0&id=c4a568c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4a568c2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VTextField})
